/**
 * APP Plus module router (P7) — replaces the P4 stub. Frontend gating is UX
 * only; the backend requireProgram guard is the enforcement point.
 */
import { Routes, Route, Navigate } from 'react-router-dom';
import { useProgramAccess } from '@/platform/ProgramAccessContext';
import AppPlusOverview from './AppPlusOverview';
import AppPlusConfiguration from './Configuration';
import QpsManagement from './QpsManagement';
// The MIPS Detail page, reused verbatim at ACO scope (D12): hosted on an APP
// route so the sidebar/pills/session program stay APP Plus while viewing it.
import MeasureDetail from '@/pages/programs/mips/gap-management/quality/Detail';
import AppPlusInsights from './Insights';
import InsightsRoster from './InsightsRoster';
import InsightsTinNpi from './InsightsTinNpi';

/** Go-live-appropriate placeholder (owner 2026-07-20) — no internal phase jargon. */
function SubmissionPlaceholder() {
  return (
    <div className="mx-auto max-w-lg py-16 text-center">
      <h2 className="text-xl font-semibold">Submission</h2>
      <p className="mt-3 text-muted-foreground">
        CMS submission packaging will be available here before the PY2026 submission
        window opens in January 2027.
      </p>
      <p className="mt-2 text-sm text-muted-foreground">
        Until then, QPS Management always reflects your current reportable data —
        nothing needs to be prepared ahead of time.
      </p>
    </div>
  );
}

export default function AppPlusModule() {
  const { hasProgram, loading } = useProgramAccess();
  if (loading) return null;
  if (!hasProgram('app-plus')) return <Navigate to="/" replace />;
  return (
    <Routes>
      {/* Overview restored 2026-07-14 (owner: it was never supposed to be removed). */}
      <Route index element={<AppPlusOverview />} />
      <Route path="configuration" element={<AppPlusConfiguration />} />
      <Route path="qps" element={<QpsManagement />} />
      <Route path="measure/:id" element={<MeasureDetail />} />
      <Route path="insights" element={<AppPlusInsights />} />
      <Route path="insights/roster-exposure" element={<InsightsRoster />} />
      <Route path="insights/tin-npi" element={<InsightsTinNpi />} />
      <Route path="submission" element={<SubmissionPlaceholder />} />
      <Route path="*" element={<Navigate to="/programs/app-plus" replace />} />
    </Routes>
  );
}
